import { AbstractAdapter } from '@shared/helpers/abstract.adapter';
import { IAuthor } from '@shared/interfaces/IAuthor.interface';
import { Injectable } from '@angular/core';

export class BlogAuthor implements IAuthor {
  id: number;
  slug: string;
  fullName: string;
  description: string;
  authorImageUrl: string;
  title: string;
  active: string;
}

@Injectable({
  providedIn: 'root'
})
export class BlogAuthorAdapter extends AbstractAdapter {
  private mapper = {
    id: {},
    slug: {},
    fullName: {},
    description: {},
    authorImageUrl: {},
    title: {},
    active: {}
  };

  constructor() {
    super();
  }

  adapt(item: any, mapper?: unknown): BlogAuthor {
    const author = new BlogAuthor();
    const adaptMapper = (typeof mapper === 'object') ? mapper : this.mapper;
    super.processMapping(adaptMapper, item, author);

    return author;
  }
}
